var _rect, _rect2, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 61,
    viewBox: "0 0 61 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 60,
    height: 60,
    rx: 7.5,
    fill: "white",
    stroke: "#D0D5DD"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 9,
    width: 42,
    height: 42,
    rx: 21,
    fill: "#1275B1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.9278 20.5382C25.9278 21.94 24.7128 23.0764 23.2139 23.0764C21.7151 23.0764 20.5 21.94 20.5 20.5382C20.5 19.1364 21.7151 18 23.2139 18C24.7128 18 25.9278 19.1364 25.9278 20.5382Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8711 24.9421H25.5103V39H20.8711V24.9421Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9794 24.9421H28.3402V39H32.9794C32.9794 39 32.9794 34.5744 32.9794 31.8073C32.9794 30.1464 33.5465 28.4783 35.8093 28.4783C38.3665 28.4783 38.3511 30.6518 38.3392 32.3356C38.3236 34.5367 38.3608 36.7828 38.3608 39H43V31.5806C42.9607 26.8431 41.7262 24.6601 37.6649 24.6601C35.2531 24.6601 33.7581 25.7551 32.9794 26.7457V24.9421Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.3ead8dc9d3f62852e181f79c22f6b4c3.svg";
export { ForwardRef as ReactComponent };